import { useSuspenseQuery } from "@tanstack/react-query";
import { actions } from "astro:actions";
import Link from "astro-typesafe-routes/link/react";

import { DialogBody } from "~/components/DialogBody";
import { DialogFooter } from "~/components/DialogFooter";
import { DialogHeader } from "~/components/DialogHeader";
import { DialogTitle } from "~/components/DialogTitle";
import { TextDefinition } from "~/components/TextDefinition";
import type { FragmentType } from "~/utils/fragment";
import { getPackFullName } from "~/utils/pack";
import { slugify } from "~/utils/slug";

import type { PreviewPack_PackFragment } from "./PreviewPack_PackFragment";

export const PreviewPack: React.FC<{
  pack: FragmentType<"Pack", { select: typeof PreviewPack_PackFragment }>;
}> = ({ pack }) => {
  const { data } = useSuspenseQuery({
    staleTime: Infinity,
    queryKey: ["pack", pack.id, "words"],
    queryFn: () => actions.pack.getWords.orThrow({ packId: pack.id }),
  });
  return (
    <>
      <DialogHeader>Preview pack terms</DialogHeader>
      <DialogBody className="space-y-6">
        <DialogTitle>{getPackFullName(pack, pack.collection)}</DialogTitle>
        <table className="table border">
          <thead>
            <tr>
              <th>#</th>
              <th>Answer</th>
              <th>Clue</th>
            </tr>
          </thead>
          <tbody>
            {data.map((word, index) => {
              const imageClue = word.definitions.find(
                (definition) => definition.image,
              );
              return (
                <tr key={word.id}>
                  <td>{index + 1}</td>
                  <td>{word.solution}</td>
                  <td>
                    {imageClue?.image ? (
                      <img
                        className="max-h-32 max-w-32"
                        src={imageClue.image}
                        alt={imageClue.text}
                      />
                    ) : (
                      word.definitions[0] && (
                        <TextDefinition definition={word.definitions[0]} />
                      )
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </DialogBody>
      <DialogFooter>
        <Link
          to="/packs/[slug]"
          params={{ slug: slugify(pack) }}
          className="btn btn-secondary btn-block"
        >
          Play pack
        </Link>
      </DialogFooter>
    </>
  );
};
